<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="margin_large_bottom single-video"
    id="video-single"
  >
    <PageHeader />
    <ModuleContainer class="single-video-content padding_large">
      <VimeoEmbed
        v-if="currentPage.acf && currentPage.acf.vimeo_video"
        :html="currentPage.acf.vimeo_video"
        :poster="currentPage.featured_image_src"
        class="single-video-embed"
      />
      <DynamicHtml
        v-if="currentPage.content && currentPage.content.rendered"
        :html="currentPage.content.rendered"
        class="single-video-description"
      />
      <Categories
        v-if="currentPage.acf && currentPage.acf._categories"
        :categories="currentPage.acf._categories"
        taxonomy="inspir_taxonomy"
      />
    </ModuleContainer>
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import VimeoEmbed from "@/components/elements/VimeoEmbed";
import Categories from "@/components/blocks/CategoriesBlock";

export default {
  name: "single-video",
  components: {
    VimeoEmbed,
    Categories
  },
  data() {
    return {};
  },
  computed: {}
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";
.single-video {
  .single-video-embed {
    margin-bottom: 30px;
  }
  .single-video-description {
    margin-bottom: 30px;
  }
}
</style>
